import {QueryBillingUnitsArgs, TeamRegionMap} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"
import billingUnitsQuery, {billingUnitsKey} from "../services/query/billingUnits"
export const useBillingUnitsQuery = createUseQuery<TeamRegionMap[], QueryBillingUnitsArgs>(billingUnitsQuery, {
  key: billingUnitsKey
})
